module.exports = __webpack_public_path__ + "pc-top-assets/img/twitter-black.1daf9a0e.svg";